import { OrderStatus, OrderlineStatusType, PayType } from '@/apis';

type RecordType<T extends string> = Record<T, string>;

export const PAY_TYPE: RecordType<PayType> = {
  phone: '핸드폰결제',
  kakao_pay: '카카오페이',
  toss_pay: '토스페이',
  naver_pay: '네이버페이',
  cash: '가상계좌',
  card: '카드',
} as const;

export const ORDERLINE_STATUS: RecordType<OrderlineStatusType> = {
  unpaid: '입금대기',
  paid: '결제완료',
  preparing: '상품준비중',
  in_transit: '배송중',
  delivered: '배송완료',
  cancel_waiting: '취소대기',
  canceled: '취소주문',
} as const;

export const ORDER_STATUS: RecordType<OrderStatus> = {
  unpaid: '입금대기',
  paid: '주문완료',
  part_canceled: '부분취소',
  canceled: '취소주문',
  cancel_waiting: '취소대기', // deprecated for v2 (v1에는 유지)
} as const;

export const PAYMENT_METHOD = {
  CARD: 'CARD',
  NAVER_PAY: 'NAVER_PAY',
  KAKAO_PAY: 'KAKAO_PAY',
  TOSS_PAY: 'TOSS_PAY',
  VIRTUAL_ACCOUNT: 'VIRTUAL_ACCOUNT',
} as const;

export const CARD_OPTIONS = [
  { value: '', label: '카드사 선택', code: '' },
  { value: 'SHINHAN', label: '신한', code: '41' },
  { value: 'HYUNDAI', label: '현대', code: '61' },
  { value: 'SAMSUNG', label: '삼성', code: '51' },
  { value: 'LOTTE', label: '롯데', code: '71' },
  { value: 'HANA', label: '하나', code: '21' },
  { value: 'KOOKMIN', label: '국민', code: '11' },
  { value: 'BC', label: '비씨', code: '31' },
  { value: 'NONGHYEOP', label: '농협', code: '91' },
  { value: 'WOORI', label: '우리', code: '33' },
  { value: 'KAKAOBANK', label: '카카오뱅크', code: '15' },
  { value: 'KBANK', label: '케이뱅크', code: '3A' },
  { value: 'IBK_BC', label: '기업', code: '3K' },
  { value: 'CITI', label: '씨티', code: '36' },
  { value: 'SAEMAUL', label: '새마을', code: '38' },
  { value: 'POST', label: '우체국', code: '37' },
  { value: 'SUHYEOP', label: '수협', code: '34' },
  { value: 'SHINHYEOP', label: '신협', code: '62' },
  { value: 'GWANGJUBANK', label: '광주은행', code: '46' },
  { value: 'JEONBUKBANK', label: '전북', code: '35' },
  { value: 'KDBBANK', label: '산업', code: '30' },
  { value: 'JEJUBANK', label: '제주', code: '42' },
  { value: 'SAVINGBANK', label: '저축', code: '39' },
  { value: 'UNIONPAY', label: 'UNIONPAY', code: '' },
];

export const REFUND_BANK_OPTIONS = [
  { value: '', label: '은행 선택' },
  { value: 'NH농협은행', label: 'NH농협은행' },
  { value: '신한은행', label: '신한은행' },
  { value: '우리은행', label: '우리은행' },
  { value: 'KB국민은행', label: 'KB국민은행' },
  { value: 'IBK기업은행', label: 'IBK기업은행' },
  { value: '카카오뱅크', label: '카카오뱅크' },
  { value: '하나은행', label: '하나은행' },
  { value: '새마을금고', label: '새마을금고' },
  { value: '부산은행', label: '부산은행' },
  { value: 'DGB대구은행', label: 'DGB대구은행' },
  { value: '우체국예금보험', label: '우체국예금보험' },
  { value: '경남은행', label: '경남은행' },
  { value: '케이뱅크', label: '케이뱅크' },
  { value: 'SC제일은행', label: 'SC제일은행' },
  { value: '신협', label: '신협' },
  { value: '광주은행', label: '광주은행' },
  { value: 'Sh수협은행', label: 'Sh수협은행' },
  { value: '씨티은행', label: '씨티은행' },
  { value: '전북은행', label: '전북은행' },
  { value: 'KDB산업은행', label: 'KDB산업은행' },
  { value: '저축은행중앙회', label: '저축은행중앙회' },
  { value: '제주은행', label: '제주은행' },
  { value: '미래에셋증권', label: '미래에셋증권' },
  { value: '산림조합', label: '산림조합' },
  { value: '삼성증권', label: '삼성증권' },
  { value: '신한금융투자', label: '신한금융투자' },
  { value: 'NH투자증권', label: 'NH투자증권' },
  { value: '대신증권', label: '대신증권' },
];

export const INSTALLMENT_OPTIONS = [
  { value: '0', label: '일시불' },
  { value: '2', label: '2개월' },
  { value: '3', label: '3개월' },
  { value: '4', label: '4개월' },
  { value: '5', label: '5개월' },
  { value: '6', label: '6개월' },
  { value: '7', label: '7개월' },
  { value: '8', label: '8개월' },
  { value: '9', label: '9개월' },
  { value: '10', label: '10개월' },
  { value: '11', label: '11개월' },
  { value: '12', label: '12개월' },
];

export const BACKUP_CHECKOUT_INFO = 'backupCheckoutInfo';
export const CHECKOUT_VERSION = 'checkoutVersion';
